import clsx from 'clsx';
import { type ReactNode, useEffect, useRef, useState } from 'react';

export function StickyFormControls(props: { children: ReactNode }) {
    const { children } = props;
    const [isStuck, setIsStuck] = useState(true);
    const sentinelRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sentinelRef.current) {
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            setIsStuck(entry.isIntersecting);
        });
        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div ref={sentinelRef} />
            <div
                className={clsx(
                    'sticky bottom-0 isolate z-10 flex justify-end border-t bg-base/80 px-4 py-2 backdrop-blur transition-colors',
                    isStuck && 'border-t-transparent'
                )}
            >
                {children}
            </div>
        </>
    );
}
